var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.985 17.792a.54.54 0 0 1-.178-.386.54.54 0 0 1 .178-.386l5.02-5.02-5.02-5.02a.54.54 0 0 1-.178-.386q0-.208.178-.416A.54.54 0 0 1 10.37 6a.54.54 0 0 1 .386.178l5.169 5.198q.148.12.207.282a1 1 0 0 1 0 .683.64.64 0 0 1-.207.283l-5.169 5.168q-.178.208-.386.208t-.386-.208"
})));
export default SvgChevronRight;